import { render, staticRenderFns } from "./ProductGroupSelectAutocomplete.vue?vue&type=template&id=177acede&scoped=true"
import script from "./ProductGroupSelectAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ProductGroupSelectAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupSelectAutocomplete.vue?vue&type=style&index=0&id=177acede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177acede",
  null
  
)

export default component.exports